import { render, staticRenderFns } from "./EmployeeEditor.vue?vue&type=template&id=2af0a09a&"
import script from "./EmployeeEditor.vue?vue&type=script&lang=ts&"
export * from "./EmployeeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports